<div class="container-fluid px-4 border-bottom">
    <div class="d-flex align-items-center">
        <button
            sfHeaderToggler
            [sfSidebarToggle]="sidebarId()"
            toggle="visible"
            aria-label="Toggle navigation"
            class="btn header-toggler"
            style="margin-inline-start: -14px"
            type="button">
            <fa-icon [icon]="['fas', 'bars']"></fa-icon>
        </button>
        <sf-staff-icon-horizontal-list
            #staffList
            [countToShow]="8"
            [showViewAllButton]="true"
            class="ps-3 d-none d-sm-block"></sf-staff-icon-horizontal-list>
    </div>
    <div class="d-flex align-items-center">
        <a
            sfButton
            class="me-1"
            size="sm"
            color="primary"
            icon="external-link"
            href="https://surefire-software.gitbook.io/docs/"
            target="_blank"
            >Docs</a
        >
        <div class="me-1 d-none d-md-block" ngbDropdown #myDrop="ngbDropdown">
            <button sfButton type="button" size="sm" color="secondary" ngbDropdownToggle>Quick Actions</button>
            <div ngbDropdownMenu>
                <a ngbDropdownItem routerLink="/appointment/0">Create Appointment</a>
                <div class="dropdown-divider"></div>
                <a
                    ngbDropdownItem
                    routerLink="/diary"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Diary</a
                >
                <a
                    ngbDropdownItem
                    routerLink="/diary/timeline"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Timeline</a
                >
                <a
                    ngbDropdownItem
                    routerLink="/diary/holiday"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Holidays</a
                >
                <a
                    ngbDropdownItem
                    routerLink="/diary/absence"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Absences</a
                >
                <a
                    ngbDropdownItem
                    routerLink="/unallocated-appointments"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    Unallocated Appointments
                </a>
                <div class="dropdown-divider"></div>
                <a
                    ngbDropdownItem
                    routerLink="/staff"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    >View Staff</a
                >
                <button ngbDropdownItem (click)="openStaffMapModal()">View Staff Map</button>
            </div>
        </div>

        <button
            sfButton
            type="button"
            class=""
            size="sm"
            color="primary"
            icon="calendar-day"
            tooltip="Pending Appointments"
            tooltipContainer="body"
            (click)="openPendingAppointmentsOffCanvas()"></button>
        <button
            sfButton
            type="button"
            class=""
            size="sm"
            color="primary"
            icon="users"
            tooltip="Recent Viewed Customers"
            tooltipContainer="body"
            (click)="openRecentCustomersOffCanvas()">
            {{ appStore.recentlyViewedCustomerCount() }}
        </button>
        <div ngbDropdown class="ms-2 d-inline-block">
            <div class="avatar" ngbDropdownToggle>
                <img [src]="appStore.me()?.picture" [alt]="appStore.me()?.fullName" />
            </div>
            <div ngbDropdownMenu>
                <button ngbDropdownItem sfButton (click)="me.open()">My Details</button>
                <button ngbDropdownItem sfButton (click)="companySettings.open()">View Settings</button>
                <a ngbDropdownItem sfButton routerLink="/account/change-password">Change Password</a>
                <div class="dropdown-divider"></div>
                <!-- @if (authService.isImpersonating) {
                    <button ngbDropdownItem (click)="authService.endImpersonation()">End Impersonation</button>
                } -->
                <button ngbDropdownItem (click)="logout()">Log Out</button>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid px-4 border-bottom">
    <sf-breadcrumb-router></sf-breadcrumb-router>
</div>

<!-- <div class="app-header container-fluid g-0">
    <div class="app-header__content">
        <div class="app-header-left">
            <button class="main-menu-button ps-3" (click)="toggleMenu()">
                <fa-icon [icon]="['fas', 'bars']"></fa-icon>
            </button>
            @if (appStore.staff()) {
                <button
                    sfButton
                    color="primary"
                    size="sm"
                    icon="briefcase"
                    class="ms-3 d-sm-none"
                    (click)="staffList.viewAll()">
                    {{ appStore.staff().length }}
                </button>
                <sf-staff-icon-horizontal-list
                    #staffList
                    [countToShow]="8"
                    [showViewAllButton]="true"
                    class="ps-3 d-none d-sm-block"></sf-staff-icon-horizontal-list>
            }
        </div>
        <div class="app-header-right">
            <div class="me-1 hide-on-mobile-sidebar-open" ngbDropdown #myDrop="ngbDropdown">
                <button sfButton type="button" size="sm" color="secondary" ngbDropdownToggle>Quick Actions</button>
                <div ngbDropdownMenu>
                    <a ngbDropdownItem routerLink="/appointment/0">Create Appointment</a>
                    <div class="dropdown-divider"></div>
                    <a
                        ngbDropdownItem
                        routerLink="/diary"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >Diary</a
                    >
                    <a
                        ngbDropdownItem
                        routerLink="/diary/timeline"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >Timeline</a
                    >
                    <a
                        ngbDropdownItem
                        routerLink="/diary/holiday"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >Holidays</a
                    >
                    <a
                        ngbDropdownItem
                        routerLink="/diary/absence"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >Absences</a
                    >
                    <a
                        ngbDropdownItem
                        routerLink="/unallocated-appointments"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }">
                        Unallocated Appointments
                    </a>
                    <div class="dropdown-divider"></div>
                    <a
                        ngbDropdownItem
                        routerLink="/staff"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                        >View Staff</a
                    >
                    <button ngbDropdownItem (click)="openStaffMapModal()">View Staff Map</button>
                </div>
            </div>
            <button
                sfButton
                type="button"
                class="hide-on-mobile-sidebar-open"
                size="sm"
                color="primary"
                icon="calendar-day"
                tooltip="Pending Appointments"
                tooltipContainer="body"
                (click)="openPendingAppointmentsOffCanvas()"></button>
            <button
                sfButton
                type="button"
                class="hide-on-mobile-sidebar-open"
                size="sm"
                color="primary"
                icon="users"
                tooltip="Recent Viewed Customers"
                tooltipContainer="body"
                (click)="openRecentCustomersOffCanvas()">
                {{ appStore.recentlyViewedCustomerCount() }}
            </button>
            <div ngbDropdown class="ms-2 d-inline-block">
                <div class="avatar" ngbDropdownToggle>
                    <img [src]="appStore.me()?.picture" [alt]="appStore.me()?.fullName" />
                </div>
                <div ngbDropdownMenu>
                    <button ngbDropdownItem sfButton (click)="me.open()">My Details</button>
                    <button ngbDropdownItem sfButton (click)="companySettings.open()">View Settings</button>
                    <a ngbDropdownItem sfButton routerLink="/account/change-password">Change Password</a>
                    <div class="dropdown-divider"></div>
                    @if (authService.isImpersonating) {
                        <button ngbDropdownItem (click)="authService.endImpersonation()">End Impersonation</button>
                    }
                    <button ngbDropdownItem (click)="logout()">Log Out</button>
                </div>
            </div>
        </div>
    </div>
</div>-->

<sf-off-canvas #me title="My Details" [offCanvasConfig]="companySettingsOffCanvasConfig">
    @if (appStore.me(); as me) {
        <div class="container-fluid small p-0 mb-3">
            <div class="row">
                <div class="col-6 fw-bold">ID</div>
                <div class="col-6 text-end">{{ me.id }}</div>
            </div>
            <div class="row">
                <div class="col-6 fw-bold">Username</div>
                <div class="col-6 text-end">{{ me.username }}</div>
            </div>
            <div class="row">
                <div class="col-6 fw-bold">Name</div>
                <div class="col-6 text-end">{{ me.fullName }}</div>
            </div>
            <div class="row">
                <div class="col-4 fw-bold">Email</div>
                <div class="col-8 text-end">{{ me.emailAddress }}</div>
            </div>
            <div class="row">
                <div class="col-6 fw-bold">Colour</div>
                <div class="col-6 text-end">{{ me.colour }}</div>
            </div>
            <div class="row">
                <div class="col-6 fw-bold">Mobile Number</div>
                <div class="col-6 text-end">{{ me.mobileNumber }}</div>
            </div>
            <div class="row">
                <div class="col-6 fw-bold">Other Number</div>
                <div class="col-6 text-end">{{ me.phoneNumber }}</div>
            </div>
        </div>

        @if (me.package; as package) {
            <p class="mb-2 fw-bold text-primary">Included in my subscribtion</p>

            @for (module of package.includedModules; track module) {
                <div class="d-block mb-2 p-4 border border-1" [ngbTooltip]="module.description">
                    <div class="d-flex align-items-center">
                        <div>
                            <fa-icon size="2x" class="text-primary" [icon]="module.icon"></fa-icon>
                        </div>
                        <div class="ms-5">
                            <span class="text-primary fw-bold">{{ module.name }}</span>
                        </div>
                    </div>
                </div>
            }

            <p class="my-2 fw-bold text-primary">Extra Modules</p>
            @for (module of package.extraActiveModules; track module) {
                <div class="d-block mb-2 p-4 border border-1" [ngbTooltip]="module.description">
                    <div class="d-flex align-items-center">
                        <div>
                            <fa-icon size="2x" class="text-primary" [icon]="module.icon"></fa-icon>
                        </div>
                        <div class="ms-5">
                            <span class="text-primary fw-bold">{{ module.name }}</span>
                        </div>
                    </div>
                </div>
            }
        }
    }
</sf-off-canvas>

<sf-off-canvas #companySettings title="Settings" [offCanvasConfig]="companySettingsOffCanvasConfig">
    <div class="d-grid mb-3">
        <button
            sfButton
            type="button"
            color="secondary"
            size="sm"
            icon="cog"
            (click)="showExtendedSettings.set(!showExtendedSettings())">
            {{ showExtendedSettings() ? 'Hide' : 'Show' }} Extended Settings
        </button>
    </div>
    @if (appStore.companySettings(); as settings) {
        <div class="small">
            <div class="row align-items-center mb-3 mb-3">
                <div class="col-6"><b>Engineer Cost Per Hour</b></div>
                <div class="col-6 text-end">{{ settings.engineerCostPerHour | currency }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Apprentice Cost Per Hour</b></div>
                <div class="col-6 text-end">{{ settings.apprenticeCostPerHour | currency }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>VAT</b></div>
                <div class="col-6 text-end">{{ settings.vat }}%</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>AM/PM Divide</b></div>
                <div class="col-6 text-end">{{ settings.ampmdivide }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Company SMS Sender</b></div>
                <div class="col-6 text-end">{{ settings.companySms }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Show Payment Details On Certificate</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.showPaymentDetailsOnCertificate"></sf-boolean-icon>
                </div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Primary Colour</b></div>
                <div class="col-6 text-end">{{ settings.primaryColour }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Secondary Colour</b></div>
                <div class="col-6 text-end">{{ settings.secondaryColour }}</div>
            </div>
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Facebook</b></div>
                    <div class="col-6 text-end">{{ settings.facebook }}</div>
                </div>
            }
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Instagram</b></div>
                    <div class="col-6 text-end">{{ settings.instagram }}</div>
                </div>
            }
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>LinkedIn</b></div>
                    <div class="col-6 text-end">{{ settings.linkedin }}</div>
                </div>
            }
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Twitter</b></div>
                    <div class="col-6 text-end">{{ settings.twitter }}</div>
                </div>
            }
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>YouTube</b></div>
                    <div class="col-6 text-end">{{ settings.youtube }}</div>
                </div>
            }
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Show Review Links</b></div>
                <div class="col-6 text-end"><sf-boolean-icon [value]="settings.showReviewLinks"></sf-boolean-icon></div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Invoice Footer</b></div>
                <div class="col-6 text-end">{{ settings.invoiceFooter }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Invoice Bank Name</b></div>
                <div class="col-6 text-end">{{ settings.invoiceBankName }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Invoice Account Name</b></div>
                <div class="col-6 text-end">{{ settings.invoiceAccountName }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Invoice Account Number</b></div>
                <div class="col-6 text-end">{{ settings.invoiceAccountNumber }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Invoice Sort Code</b></div>
                <div class="col-6 text-end">{{ settings.invoiceSortCode }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>VAT Number</b></div>
                <div class="col-6 text-end">{{ settings.vatnumber }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Engineer En Route</b></div>
                <div class="col-6 text-end"><sf-boolean-icon [value]="settings.engineerEnRoute"></sf-boolean-icon></div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Warn If No Post</b></div>
                <div class="col-6 text-end"><sf-boolean-icon [value]="settings.warnIfNoPost"></sf-boolean-icon></div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Setup Chaser Appointment</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.setupChaserAppointment"></sf-boolean-icon>
                </div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Month Holiday Renews</b></div>
                <div class="col-6 text-end">{{ settings.monthHolidayRenews }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Smart Quote Send SMS</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.smartQuoteSendSms"></sf-boolean-icon>
                </div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Smart Quote Setup Chaser</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.smartQuoteSetupChaser"></sf-boolean-icon>
                </div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Smart Quote Combined Lines</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.smartQuoteCombinedLines"></sf-boolean-icon>
                </div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Smart Quote Parts Markup</b></div>
                <div class="col-6 text-end">{{ settings.smartQuotePartsMarkup }}%</div>
            </div>
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Preferred Accounts System ID</b></div>
                    <div class="col-6 text-end">{{ settings.preferredAccountsSystemId }}</div>
                </div>
            }
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Send Timeslot SMS</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.engineerTimeSlotSms"></sf-boolean-icon>
                </div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Gas Safe No.</b></div>
                <div class="col-6 text-end">{{ settings.gasSafeNumber }}</div>
            </div>
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Show payment on app</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.showPaymentOnApp"></sf-boolean-icon>
                </div>
            </div>
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Check Order Reminder</b></div>
                    <div class="col-6 text-end">
                        <sf-boolean-icon [value]="settings.checkOrderReminder"></sf-boolean-icon>
                    </div>
                </div>
            }
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Can Import Products</b></div>
                    <div class="col-6 text-end">
                        <sf-boolean-icon [value]="settings.canImportProducts"></sf-boolean-icon>
                    </div>
                </div>
            }
            <div class="row align-items-center mb-3">
                <div class="col-6"><b>Allow online bookings</b></div>
                <div class="col-6 text-end">
                    <sf-boolean-icon [value]="settings.allowOnlineBookings"></sf-boolean-icon>
                </div>
            </div>
            @if (showExtendedSettings()) {
                <div class="row align-items-center mb-3">
                    <div class="col-6"><b>Update Quote Wizard Prices</b></div>
                    <div class="col-6 text-end">
                        <sf-boolean-icon [value]="settings.updateQuoteWizardPrices"></sf-boolean-icon>
                    </div>
                </div>
            }
        </div>
    }
</sf-off-canvas>
